import { useEffect, useRef } from "react";
import func from "@uikit/func";

function CustomJsFunction(props) {
  const iframeComsRef = useRef(null);

  useEffect(() => {
    let htmlValue = props.content;
    if (props.content?.type === "protein") {
      htmlValue = `<!DOCTYPE html>
      <html>
        <head>
          <link href="https://cdn.jsdelivr.net/npm/molstar@3.31.3/build/viewer/molstar.min.css" rel="stylesheet">
          <script src="https://cdn.jsdelivr.net/npm/molstar@3.31.3/build/viewer/molstar.min.js"></script>
        </head>
        <body>
        <div id="molstar_content"></div>
        </body>
        <script>
          molstar.Viewer.create('molstar_content', {
            layoutShowControls: false,
          }).then(viewer => {
            var structureUrl = 'https://alphafold.ebi.ac.uk/files/${props.content.value}-model_v4.cif';
            if (structureUrl) viewer.loadStructureFromUrl(structureUrl, 'mmcif', false);
          });
        </script>
      </html>
    `;
    }
    const onlyId = `custom-iframe-coms-${props.editorId}`;
    const existedIframe = document.getElementById(onlyId);
    // 移除旧的
    if (!func.isEmpty(existedIframe)) {
      if (func.isEmpty(iframeComsRef.current)) return;
      iframeComsRef.current.removeChild(existedIframe);
      if (func.isEmpty(htmlValue)) return;
    }
    // 创建新的iframe标签
    const iframe = document.createElement("iframe");
    // 设置属性
    iframe.setAttribute("id", onlyId);
    // iframe.setAttribute('class', 'custom-iframe')
    // 挂载到指定元素后
    iframeComsRef.current.appendChild(iframe);

    let iframedoc = iframe.document;
    if (iframe.contentDocument) iframedoc = iframe.contentDocument;
    else if (iframe.contentWindow) iframedoc = iframe.contentWindow.document;

    if (iframedoc) {
      iframedoc.open();
      iframedoc.writeln(htmlValue);
      iframedoc.close();
    } else {
      func.customMsg({
        content: "Unable to render html code",
        type: "warning",
      });
    }

    const bodyScrollHeight = iframedoc?.body?.scrollHeight;
    const bodyClientHeight = iframedoc?.body?.clientHeight;
    const minHeight = 300;
    // 可滚动高度大于可视高度，并且大于最小高度 minHeight
    if (bodyScrollHeight > bodyClientHeight && bodyScrollHeight > minHeight) {
      iframe.style.minHeight = `${bodyClientHeight > 800 ? 800 : bodyScrollHeight}px`;
    } else {
      iframe.style.minHeight = `${minHeight}px`;
    }
    iframe.style.minWidth = "100%";
    iframe.style.width = "100%";
  }, [props.content]);

  return <div className={`${props.fontSize}`} ref={iframeComsRef}></div>;
}

export default CustomJsFunction;
